import useQueryApiClient from "../../../../utils/useQueryApiClient";
import { useAuth } from "hooks/useAuth";

export function useCategories() {
  const { user } = useAuth()
  const farmId = user?.farmId;

  return useQueryApiClient({
    request: {
      url: '/api/v2/farms/' + farmId + '/coupons/categories',
    }
  });
}